import { User, UserManager } from 'oidc-client-ts';
import { config } from '../config';

export const userManager = new UserManager({
  authority: config.oidc.authority,
  client_id: config.oidc.clientId,
  redirect_uri: window.location.origin,
  post_logout_redirect_uri: window.location.origin,
  scope: [
    'openid',
    'profile',
    'email',
    'offline_access',
    `urn:zitadel:iam:org:project:id:${config.oidc.projectId}:aud`,
    'urn:zitadel:iam:org:projects:roles',
  ].join(' '),
});

let renewal: Promise<User | null> | undefined;

export async function getAccessToken(): Promise<string | undefined> {
  const user = await userManager.getUser();
  if (!user) return undefined;
  if (!user.expired) return user.access_token;

  renewal ??= userManager.signinSilent().finally(() => {
    renewal = undefined;
  });

  try {
    return (await renewal)?.access_token;
  } catch (error) {
    console.error('Silent token renewal failed:', error);
    return undefined;
  }
}
